export function Pluarlise(value: string, count: number): string {
    return `${value}${count > 1 ? "s" : ""}`;
}